import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuthedApi, errMsg } from "@/lib/api";

const LABEL = { admin: "Administrador", editor: "Editor (pode cadastrar)", pendente: "Pendente (sem acesso)" };

export default function UsersPage() {
  const api = useAuthedApi();
  const [data, setData] = useState({ roles: [], users: [] });

  useEffect(() => {
    api("get", "/users").then(setData).catch((e) => toast.error(errMsg(e)));
  }, [api]);

  const setRole = async (u, role) => {
    try {
      await api("patch", `/users/${u.user_id}/role`, { role });
      setData((d) => ({ ...d, users: d.users.map((x) => (x.user_id === u.user_id ? { ...x, role } : x)) }));
      toast.success("Permissão atualizada");
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <main data-testid="users-page" className="relative z-10 mx-auto max-w-4xl px-4 pb-24 pt-10 sm:px-8">
      <Link to="/painel" data-testid="back-to-dashboard-link" className="mb-6 inline-flex items-center gap-2 text-sm text-slate-400 hover:text-amber-400"><ArrowLeft size={16} />Voltar ao painel</Link>
      <h1 className="font-display text-4xl font-extrabold uppercase sm:text-5xl">Usuários</h1>
      <p className="mt-2 mb-8 max-w-2xl text-sm text-slate-400">Quem cria uma conta em "Entrar" aparece aqui como <b>Pendente</b>. Mude para <b>Editor</b> para autorizar a pessoa a cadastrar e editar eventos.</p>
      <div className="divide-y divide-slate-800 rounded-md border border-slate-800 bg-slate-900/60">
        {data.users.length === 0 && <p className="p-6 text-center text-slate-500">Nenhum usuário ainda.</p>}
        {data.users.map((u) => (
          <div key={u.user_id} data-testid={`user-row-${u.user_id}`} className="flex flex-col gap-3 p-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="min-w-0">
              <div className="truncate font-medium">{u.name || u.email || u.user_id}</div>
              <div className="truncate text-xs text-slate-500">{u.email}</div>
            </div>
            <select data-testid={`user-role-select-${u.user_id}`} value={u.role} onChange={(e) => setRole(u, e.target.value)} className="h-10 rounded-sm border border-slate-700 bg-slate-950 px-3 text-sm">
              {data.roles.map((r) => <option key={r} value={r}>{LABEL[r] || r}</option>)}
            </select>
          </div>
        ))}
      </div>
    </main>
  );
}
